import { detectImageMime } from '../../lib/brdocs/parsers/cnh/cnh-binary';
import { DecodedPhoto } from '../../lib/brdocs';
import { jp2ToDataUrl } from '../cnh/jp2';
import { bpgToDataUrl } from '../cnh/bpg';

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

/**
 * Browser implementation of the library's PhotoDecoder: turns embedded
 * document-photo bytes into a renderable data URL. Handles JPEG/PNG directly,
 * JPEG 2000 (vendored pure-JS decoder) and BPG (vendored libbpg/asm.js).
 */
export async function browserPhotoDecoder(bytes: Uint8Array): Promise<DecodedPhoto> {
  const { mime, renderable, label } = detectImageMime(bytes);
  if (renderable) {
    const url = await blobToDataUrl(new Blob([bytes.slice()], { type: mime }));
    return { dataUrl: url, format: label };
  }
  if (mime === 'image/jp2') {
    const url = jp2ToDataUrl(bytes);
    if (url) return { dataUrl: url, format: `${label} → PNG` };
  }
  if (mime === 'image/bpg') {
    const url = await bpgToDataUrl(bytes);
    if (url) return { dataUrl: url, format: `${label} → PNG` };
  }
  return { format: label };
}
